(() => {
  'use strict';
  const quickbuySelector = 'select-option[data-item="overlay-quickbuy"], button-quickview[data-item="overlay-quickbuy"]';
  const dialogTriggerSelector = `${quickbuySelector}, product-addons[data-custom-class="size_chart"]`;
  const selector = `${dialogTriggerSelector}, button-wishlist, button-compare`;
  const dialogSelector = '.quickview.tingle-modal--visible:not(.remove-loading), .size_chart.tingle-modal--visible:not(.remove-loading)';
  const focusableSelector = 'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]';
  const clicks = new WeakMap();
  const spaceStarts = new WeakMap();
  const dialogOpeners = new WeakMap();
  let activeDialog = null;
  let pendingOpener = null;
  let dialogOpener = null;
  const targetFor = event => event.target instanceof Element ? event.target.closest(selector) : null;
  const disabled = target => target.getAttribute('aria-disabled') === 'true' || target.hasAttribute('disabled');
  const enhance = scope => {
    const controls = scope.matches?.(selector) ? [scope, ...scope.querySelectorAll(selector)] : scope.querySelectorAll?.(selector) || [];
    controls.forEach(control => {
      control.setAttribute('role', 'button');
      if (control.matches(dialogTriggerSelector)) control.setAttribute('aria-haspopup', 'dialog');
      if (!control.hasAttribute('tabindex')) control.tabIndex = 0;
      if (!control.hasAttribute('aria-label') || control.hasAttribute('data-broek-action-label')) {
        const label = control.querySelector('.hidden-on-load:not(svg), .tooltip-content')?.textContent.trim() || control.getAttribute('data-text-header');
        if (label) {
          control.setAttribute('aria-label', label);
          control.setAttribute('data-broek-action-label', '');
        }
      }
    });
  };
  document.addEventListener('click', event => {
    const target = targetFor(event);
    if (target) {
      clicks.set(target, (clicks.get(target) || 0) + 1);
      if (target.matches(dialogTriggerSelector)) pendingOpener = target;
    }
  }, true);
  document.addEventListener('keydown', event => {
    const target = targetFor(event);
    if (!target || disabled(target) || event.repeat) return;
    const count = clicks.get(target) || 0;
    if (event.key === ' ') spaceStarts.set(target, count);
    if (event.key === 'Enter') queueMicrotask(() => {
      if (!event.defaultPrevented && target.isConnected && !disabled(target) && (clicks.get(target) || 0) === count) target.click();
    });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === ' ' && targetFor(event)) event.preventDefault();
  });
  document.addEventListener('keyup', event => {
    const target = targetFor(event);
    if (event.key !== ' ' || !target || !spaceStarts.has(target)) return;
    const count = spaceStarts.get(target);
    spaceStarts.delete(target);
    queueMicrotask(() => {
      if (!event.defaultPrevented && target.isConnected && !disabled(target) && (clicks.get(target) || 0) === count) target.click();
    });
  }, true);
  document.addEventListener('focusout', event => {
    const target = targetFor(event);
    if (target) spaceStarts.delete(target);
  });
  const cartIsOpen = () => Boolean(document.querySelector('#minicart_wrapper.open'));
  const isTopDialog = dialog => {
    const dialogs = document.querySelectorAll('.tingle-modal--visible:not(.remove-loading)');
    return dialogs[dialogs.length - 1] === dialog;
  };
  const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const focusable = dialog => [...dialog.querySelectorAll(focusableSelector)].filter(element =>
    element.tabIndex >= 0 && !element.matches(':disabled') && !element.closest('[inert], [hidden], [aria-hidden="true"]') && visible(element)
  );
  const focusStart = dialog => (focusable(dialog)[0] || dialog).focus({ preventScroll: true });
  const syncDialog = () => {
    const dialogs = document.querySelectorAll(dialogSelector);
    const nextDialog = dialogs[dialogs.length - 1] || null;
    if (nextDialog === activeDialog) return;
    const previous = activeDialog;
    activeDialog = nextDialog;
    if (previous && ![...dialogs].includes(previous)) {
      const previousOpener = dialogOpeners.get(previous);
      if (previousOpener?.isConnected && !cartIsOpen() && (previous.contains(document.activeElement) || document.activeElement === document.body)) {
        previousOpener.focus({ preventScroll: true });
      }
    }
    if (!nextDialog) {
      dialogOpener = null;
      return;
    }
    dialogOpener = dialogOpeners.get(nextDialog) || pendingOpener || document.activeElement;
    dialogOpeners.set(nextDialog, dialogOpener);
    pendingOpener = null;
    nextDialog.setAttribute('role', 'dialog');
    nextDialog.setAttribute('aria-modal', 'true');
    nextDialog.tabIndex = -1;
    const title = nextDialog.querySelector('.product-detail__title, .tingle-modal-box__header, h1, h2')?.textContent.trim();
    const label = title || dialogOpener?.getAttribute('aria-label');
    if (label && !nextDialog.hasAttribute('aria-labelledby')) nextDialog.setAttribute('aria-label', label);
    const closeLabel = nextDialog.querySelector('[data-broek-close-label]')?.getAttribute('data-broek-close-label') || dialogOpener?.getAttribute('data-broek-close-label');
    const closeControl = nextDialog.querySelector('.tingle-modal__close, .dlg-close-x');
    if (closeLabel && closeControl) closeControl.setAttribute('aria-label', closeLabel);
    requestAnimationFrame(() => {
      if (activeDialog === nextDialog && isTopDialog(nextDialog) && !cartIsOpen() && !nextDialog.contains(document.activeElement)) focusStart(nextDialog);
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !activeDialog || !isTopDialog(activeDialog) || cartIsOpen()) return;
    const items = focusable(activeDialog);
    const first = items[0];
    const last = items[items.length - 1];
    if (!first) {
      event.preventDefault();
      activeDialog.focus({ preventScroll: true });
    } else if (!activeDialog.contains(document.activeElement) || (!event.shiftKey && document.activeElement === last) || (event.shiftKey && (document.activeElement === first || document.activeElement === activeDialog))) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
    }
  });
  document.addEventListener('focusin', event => {
    if (activeDialog && isTopDialog(activeDialog) && !cartIsOpen() && !activeDialog.contains(event.target)) focusStart(activeDialog);
  });
  const start = () => {
    enhance(document);
    syncDialog();
    new MutationObserver(records => {
      records.forEach(record => {
        record.addedNodes.forEach(node => {
          if (node.nodeType === 1) enhance(node);
        });
        const control = record.target.parentElement?.closest(selector);
        if (control) enhance(control);
      });
      syncDialog();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'], characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
